import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-escort',
  template: `
`,
  styles: []
})
export class EscortComponent implements OnInit {
  isShowIcon = false;
  constructor() { }

  ngOnInit(): void {
  }

}
